const PageNames = [        
        { label: 'Admin Attack Types', value: 'adminAttackTypes'  },
        { label: 'Admin Features', value: 'adminFeatures'  },
        { label: 'Admin Notifications', value: 'adminNotifications'  },
        { label: 'Admin Simulations', value: 'adminAttackSimulations'  },
        { label: 'Admin Tooltips', value: 'adminTooltips'  },
        { label: 'Admin Whats New', value: 'adminWhatsNew'  },
        { label: 'Alerts', value: 'alerts' },
        { label: 'Applications', value: 'applications' },
        { label: 'Bandwidth Usage', value: 'bandwidthUsage'  },
        { label: 'Threat Hunting', value: 'threatHunting'  },
        { label: 'Beacon Threathunt', value: 'beaconThreathunt'  },
        { label: 'Change Password', value: 'changePassword'  },
        { label: 'CVE Info', value: 'cveInfo'  },
        { label: 'CVE Details', value: 'cveDetails'  },
        { label: 'Features', value: 'features'  },
        { label: 'Forgot Password', value: 'forgotPassword'  },
        { label: 'Groups', value: 'groups'  },
        { label: 'Host Information', value: 'hostInformation'  },
        { label: 'Install Shippers', value: 'installShippers'  },
        { label: 'Install CST Shippers', value: 'installCstShippers'  },
        { label: 'Install Mac Shippers', value: 'installMacShippers'  },
        { label: 'Inventory', value: 'inventory'  },
        { label: 'Linux Shippers', value: 'linuxShippers'  },
        { label: 'Linux CST Shippers', value: 'linuxCstShippers'  },
        { label: 'Mac CST Shippers', value: 'macCstShippers'  },
        { label: 'Metrics', value: 'metrics'  },
        { label: 'NeTERS', value: 'neters'  },
        { label: 'Operator Guide', value: 'operatorGuide'  },
        { label: 'Options', value: 'options'  },
        { label: 'Options Approved List', value: 'optionsApprovedList'  },
        { label: 'Options Deny List', value: 'optionsDenyList'  },
        { label: 'Options Required List', value: 'optionsRequiredList'  },
        { label: 'PhenTalk', value: 'phenTalk'  },
        { label: 'PTVS Overview', value: 'ptvsOverview'  },
        { label: 'PTVS Details', value: 'ptvsDetails'  },
        { label: 'PTVS Threat Response', value: 'ptvsThreatResponse'  },
        { label: 'Settings', value: 'settings'  },
        { label: 'Severities Found', value: 'severitiesFound'  },
        { label: 'Severities Found Table', value: 'severitiesFoundTable'  },
        { label: 'Shippers', value: 'shippers'  },
        { label: 'Simulator', value: 'simulator'  },
        { label: 'SLA Alerts', value: 'slaAlerts'  },
        { label: 'Source IPs', value: 'sourceIps'  },
        { label: 'Systems', value: 'systems'  },
        { label: 'Users', value: 'users'  },
        { label: 'Users And Systems', value: 'usersAndSystems'  },
        { label: 'User Profile', value: 'userProfile'  },
        { label: 'Weekly Failed Logins', value: 'weeklyFailedLogins'  },
        { label: 'Whats New', value: 'whatsNew'  },
    ];

export default PageNames;